export default "/images/0668bf01c7c9161ff7ec599ed9a460b3.avif";